var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"modal-class":"yuri-modal","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header":"","hide-footer":""}},[_vm._t("header"),_vm._t("default"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }